"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtractorType = void 0;
var ExtractorType;
(function (ExtractorType) {
    ExtractorType["CSV_S3"] = "CSV_S3";
    ExtractorType["DynamoDB"] = "DynamoDB";
    ExtractorType["SalesForce"] = "SalesForce";
    ExtractorType["WebServiceApi"] = "WebServiceApi";
    ExtractorType["QueryParams"] = "QueryParams";
    ExtractorType["Custom"] = "Custom";
    ExtractorType["CustomLambda"] = "CustomLambda";
    ExtractorType["Dummy"] = "Dummy";
    ExtractorType["TrayGenericEntity"] = "TrayGenericEntity";
    ExtractorType["TrayGoogleSheets"] = "TrayGoogleSheets";
    ExtractorType["TrayMarketo"] = "TrayMarketo";
})(ExtractorType = exports.ExtractorType || (exports.ExtractorType = {}));
//# sourceMappingURL=baseExtractor.js.map